<template>
  <b-container class="highlight-container">

    <router-link to="/"><i class="fas fa-times btn--close"></i></router-link>

    <b-row>
      <b-col md="12" class="text-center px-0">
        <h1 v-scroll-reveal>A Collaboration <br>from 3 Top <br>GTA Builders</h1>
        <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/builders-highlight-banner.png" fluid center alt="New Seaton Award Winning Builders"/>
        </div>
      </b-col>
    </b-row>

    <b-row class="background--white">
      <b-col md="10" offset-md="1" class="text-center">
        <h3 class="text--red text--extrabold mb-25"><a data-fancybox="video" href="https://player.vimeo.com/video/359571557?title=0&byline=0&portrait=0&transparent=0">WATCH VIDEO</a></h3>
        <p v-scroll-reveal>
          In life, things are just better when great teams work together. This is especially true at <br class="d-none d-xl-block">New
          Seaton, where three of the GTA's most respected builders have joined forces to create <br class="d-none d-xl-block">a
          very special family home community.
        </p>
        <p v-scroll-reveal>
          You can click the logos at the bottom of the page to get to know each builder individually. <br class="d-none d-xl-block">We
          look forward to getting to know you better when you come to explore our incredible <br class="d-none d-xl-block">selection
          of family homes.
        </p>
        <highlight-footer slot="register" />
      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
  import highlightFooter from '@/components/HighlightFooter';
  export default {
    components: {
      highlightFooter
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation()
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }
</script>

<style scoped>

</style>